import React, { FC } from 'react';
import s from './PreviewSection.module.css';
import PreviewGenerator from "../preview-social-network/PreviewGenerator";
import PostButton from "../post-button/PostButton";
import {useDispatch, useSelector} from "react-redux";
import {selectIsPreviewVisible} from "../../../../store/selectors/projectSelectors";
import {useAppDispatch} from "../../../../store/store";
import {setIsPreviewVisible} from "../../../../store/slices/projectSlice";

interface PreviewSectionProps {
    value: string;
    imageUrl: string|null;

}

const PreviewSection: FC<PreviewSectionProps> = ({ value, imageUrl }) => {
    const isPreviewVisible=useSelector(selectIsPreviewVisible)
    const dispatch = useAppDispatch();
    const handleClosePreview=()=>{
        dispatch(setIsPreviewVisible(false))

    }
    return (
        <>
            <div className={s.preview_container}>
                <PreviewGenerator postText={value} image={imageUrl} />
                <PostButton postText={value} image={imageUrl} />
            </div>
            {isPreviewVisible && (
                <div className={s.mobile_preview_container}
                     onClick={(e) => {
                         if (e.target === e.currentTarget) {
                             handleClosePreview();
                         }
                     }}
                >
                    <PreviewGenerator postText={value} image={imageUrl} />
                    <PostButton postText={value} image={imageUrl} />
                </div>
            )}
        </>
    );
};

export default PreviewSection;
